import { render, staticRenderFns } from "./RequestDocumentsModal.vue?vue&type=template&id=2938f16c&"
import script from "./RequestDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./RequestDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./RequestDocumentsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports